// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "js/vendors" + "." + "cf2cd02cea3ec1234abd" + ".css";
};